import React from "react";
import { useSelector } from "react-redux";
import Modal from "../../Elements/Modal/Modal";
import Button from "../../Elements/Button/Button";
import { reloadGame } from "../../State/Slices/gameSettingsSlice";

const CreditModal = () => {
  const { modalOpen } = useSelector((state) => state.modal);

  return (
    <Modal
      name="credit"
      modifier="modalCredit"
      active={modalOpen}
      title="no_credit"
    >
      <Button
        text="reload"
        title="reload"
        modifier="buttonStandard"
        action={() => reloadGame()}
      />
    </Modal>
  );
};

export default CreditModal;
